
type JsonPayload = {
    batchErrors: string[];
    jobErrors: Record<string, string>,
    type: "BatchJobSubmissionException"
}

export default class BatchJobSubmissionException extends Error {
    public batchErrors: string[];
    public jobErrors: Record<string, string>;

    constructor(payload: JsonPayload) {
        super("Batch job submission failed");
        this.batchErrors = payload.batchErrors;
        this.jobErrors = payload.jobErrors;
    }
}
